<div class="control-wrapper">
  <div clickOutside (clickOutside)="close()"  class="select-wrapper" [class.disabled]="disable">
    <div class="select-control-wrapper" (click)="toggleList()"  >
      <input type="text" class="searchable-input" [class.validation-error]="validationRequired && showValidation" 
      [(ngModel)]="searchTerm" [placeholder]="placeHolder" [disabled]="disable"
        (input)="filterItems()" />
      <span class="dorpdown-icon"></span>
      <div *ngIf="showListItems">
        <ul *ngIf="filteredItems.length > 0" class="searchable-list">
          <li *ngFor="let item of filteredItems" (click)="selectItem(item)" class="searchable-list-items valid-item">
            {{ item?.text }}
          </li>
        </ul>
        <ul *ngIf="filteredItems.length === 0" class="searchable-list">
          <li class="searchable-list-items noDataFoundMessage">{{noDataFoundMessage}}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <span *ngIf="validationRequired && showValidation"
  class="validation">{{validationMessage}}</span>
</div>
